/** @jsx jsx */
import { jsx } from '@emotion/core';
import { modalIds, ModalsConsumer } from '../../../contexts/ModalsContext';
import Modal from '../../ui/Modal';
import Enquiry from '../Enquiry';
import { enquiryContainerCss, closeButtonCss } from './index.styles';
import { SafePureComponent } from '../../../utils/SafePureComponent';

export class EnquiryModal extends SafePureComponent {
  safeRender() {
    const { props } = this;

    return (
      <ModalsConsumer>
        {({ currentModal, closeModal, formFields }) => {
          return (
            <Modal
              isOpen={currentModal === modalIds.enquiry}
              onRequestClose={closeModal}
              customCloseButtonCss={closeButtonCss}
            >
              <Enquiry
                {...props}
                closeModal={closeModal}
                defaultFields={formFields}
                hideGoBack
                isModal
                styles={{ container: enquiryContainerCss }}
              />
            </Modal>
          );
        }}
      </ModalsConsumer>
    );
  }
}

EnquiryModal.displayName = 'EnquiryModal';

export default EnquiryModal;
